import { Grid } from '@mui/material';
import React from 'react';
import ButtonImageLabel from '../../UI/ButtonImageLabel';
import ParcelaPendenteIcon from '../../../shared/assets/img/financeiro/pendente.png';
import ParcelaVencerIcon from '../../../shared/assets/img/financeiro/parcela_a_vencer.png';
import HistoricoIcon from '../../../shared/assets/img/financeiro/historico.png';


const FinanceiroMenuV2 = ({
    handleParcelaPendente,
    handleParcelaVencer,
    handleHistorico,
}) => {

    return (
        <Grid container direction='row' spacing={3} >
            <Grid
                justifyContent='center'
                size={{
                    xs: 12,
                    md: 4,
                    xl: 2
                }}>
                <ButtonImageLabel
                    description='Parcela(s) Pendente(s)'
                    image={ParcelaPendenteIcon}
                    onClick={handleParcelaPendente}
                />
            </Grid>
            <Grid
                justifyContent='center'
                size={{
                    xs: 12,
                    md: 4,
                    xl: 2
                }}>
                <ButtonImageLabel
                    description='Parcela(s) a Vencer'
                    image={ParcelaVencerIcon}
                    onClick={handleParcelaVencer}
                />
            </Grid>
            <Grid
                justifyContent='center'
                size={{
                    xs: 12,
                    md: 4,
                    xl: 2
                }}>
                <ButtonImageLabel
                    description='Histórico'
                    image={HistoricoIcon}
                    onClick={handleHistorico}
                />
            </Grid>
        </Grid>
    );
}

export default FinanceiroMenuV2;